import Component from "@glimmer/component"
import type { CardStack } from "@shared/models/card-stack"

interface Signature {
  Args: {
    model: {
      cardStack: CardStack
    }
    order: number
    closeModal: () => void
  }
}

export default class LessonHistory extends Component<Signature> {}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Planner::Modals::LessonHistory": typeof LessonHistory
  }
}
